module.exports = __webpack_public_path__ + "img/ik.5c163941.jpg";